.arrow {
  background-repeat: no-repeat;
  position: absolute;

  &:where([data-position*='top']) {
    height: 7px;
    left: 50%;
    top: 100%;
    width: 27px;
    transform: translateX(-50%);
  }

  &:where([data-position*='bottom']) {
    bottom: 100%;
    height: 7px;
    left: 50%;
    width: 27px;
    transform: translateX(-50%);
  }

  &:where([data-position='bottom-start'], [data-position='top-start']) {
    left: 0;
    transform: none;
  }

  &:where([data-position='bottom-end'], [data-position='top-end']) {
    left: unset;
    right: 0;
    transform: none;
  }

  &:where([data-position*='right']) {
    height: 27px;
    right: 100%;
    top: 50%;
    width: 7px;
    transform: translateY(-50%);
  }

  &:where([data-position*='left']) {
    height: 27px;
    left: calc(100% - 1px);
    top: 50%;
    width: 7px;
    transform: translateY(-50%);
  }

  &:where([data-position='right-start'], [data-position='left-start']) {
    top: 0;
    transform: none;
  }

  &:where([data-position='right-end'], [data-position='left-end']) {
    bottom: 0;
    top: unset;
    transform: none;
  }

  /* Override transforms when positioned by floating UI */
  &:where([data-floating-ui-positioned]) {
    transform: none;
  }

  svg {
    float: left;
  }
}
